<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size:15px; font-weight: bold">update labour charges</small>
      </legend>
      <div>
        <form @submit.prevent="updatingLabour()">
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Description</th>
                      <th scope="col">Truck</th>
                      <th scope="col">Unit</th>
                      <th scope="col">Unit price</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(labour_product, k) in EditLabourCharges" :key="k">
                      <td scope="row">
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="deleteRow(k, labour_product)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                        <!-- <i class="fa fa-trash-alt" @click="deleteRow(k, labour_product)"></i> -->
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="text"
                          v-model="labour_product.labour_description"
                          required
                        />
                      </td>
                      <td>
                          <select
                      class="form-control product_id"
                      v-model="labour_product.truck_id"
                   
                    >
                      <option value>Select product</option>
                      <option
                        v-for="truck in systemTrucks"
                        :value="truck.id"
                        :key="truck.id"
                      >{{ truck.truck_no }}</option>
                    </select>
                        <!-- <model-list-select
                          :list="systemTrucks"
                          v-model="labour_product.truck_id"
                          option-value="id"
                          option-text="truck_no"
                          placeholder="select truck name"
                        ></model-list-select> -->
                      </td>
                      <td>
                        <select
                          name="labour_measurement"
                          class="form-control input_rounded labour_measurement"
                          v-model="labour_product.labour_measurement"
                        >
                          <option value>Select Measurement</option>
                          <option value="KG">KILOGRAMS</option>
                          <option value="PCS">PIECES</option>
                          <option value="LTS">LITRES</option>
                          <option value="SET">SET</option>
                          <option value="PAIR">PAIR</option>
                          <option value="MTR">METRES</option>
                          <option value="N/A">N/A</option>
                        </select>
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="labour_product.unit_price"
                          @change="calculateLineTotal(labour_product)"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="labour_product.qty"
                          @change="calculateLineTotal(labour_product)"
                        />
                      </td>

                      <td>
                        <input
                          readonly
                          class="form-control text-right"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="labour_product.total_price"
                        />
                      </td>
                    </tr>
                    <tr v-show="EditLabourCharges.length === 0">
                      <td colspan="6">
                        <p class="text-center alert-danger p-2">No products added/available.</p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="6" class="text-right">Sub Total</td>
                      <input
                        readonly
                        class="form-control text-right sub_total"
                        type="number"
                        min="0"
                        step=".01"
                        :value="Total.toFixed(2)"
                      />
                    </tr>
                    <tr>
                      <td colspan="6" class="text-right">Total</td>
                      <input
                        readonly
                        class="form-control text-right labour_total"
                        type="number"
                        min="0"
                        step=".01"
                        :value="Total.toFixed(2)"
                      />
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div class="clearfix"></div>
            <button type="submit" class="btn btn-primary btn-flat updatingLabour btn-rounded">
              <i class="fa fa-plus"></i> update Labour charge
            </button>
            <button type="button" class="btn-rounded btn-flat updatingLabourLoader btn-rounded">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
            </button>
          </div>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModelListSelect } from "vue-search-select";
import router from "../router/index";
export default {
     data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0
    };
  },
   created() {
       if (this.$store.getters.EditLabourCharges.length === 0) {
      router.push("/managelabourcharges");
    }
    this.loadTrucks();
  },
  computed: {
    ...mapGetters(["EditLabourCharges", "systemTrucks"]),
     Total() {
      return this.EditLabourCharges.reduce(
        (acc, item) => acc + item.unit_price * item.qty,
        0
      );
    }
  },
   methods: {
    ...mapActions(["updatingLabour", "loadTrucks"]),

    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.EditLabourCharges.reduce(function(sum, product) {
        var lineTotal = parseFloat(product.total_price);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(labour_product) {
      var total =
        parseFloat(labour_product.unit_price) * parseFloat(labour_product.qty);
      if (!isNaN(total)) {
        labour_product.total_price = total.toFixed(2);
      }
      this.calculateTotal();
    },
    deleteRow(index, labour_product) {
      var idx = this.EditLabourCharges.indexOf(labour_product);
      console.log(idx, index);
      if (idx > -1) {
        this.EditLabourCharges.splice(idx, 1);
      }
      this.calculateTotal();
    }
  },
  components: {
    ModelListSelect
  }
    
}
</script>
<style scoped>
.updatingLabourLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/labour/editlabour.vue